import {Link} from 'react-router-dom';

function Expire() {
    return (
        <div style={{
        textAlign: "center",
        padding: "50px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100vh"
        }}>
            <h1>Session expirée</h1>
            <p>Votre session a expiré. Veuillez vous reconnecter pour continuer.</p>
            <Link to="/login">
                <button>Se reconnecter</button>
            </Link>
        </div>
  );
}

export default Expire;